<template>
    <div>
        <div class="app-reg-info" id="alert"  v-if="registrationInfo">
            <div v-if="!registrationInfo.registrationInformation || $store.state.guestLogin.activeAlert">
                <SystemAlert/>
            </div> 
            <div v-if="registrationInfo.registrationInformation">
                <div class="app-reg-info-row" v-for="(registrationInformation, i) in registrationInfo.registrationInformation" :key="i">                                          
                    <div class="app-reg-info-group">
                        <div class="app-reg-flex">
                            <div class="app-reg-info-child-group">
                                <span for="vehicleText" class="vehicleText">{{ registrationInformation.year }} {{ registrationInformation.make }} {{ registrationInformation.model !='UNKNOWN' ? registrationInformation.model : '' }}</span>
                            </div> 
                            <div class="app-reg-info-child-group">
                                <label for="vehicleVin">VIN</label>                
                                <span for="vehicleVinText">{{ registrationInformation.vin }}</span>
                            </div>
                            <div class="app-reg-info-child-group">    
                                <label for="vehiclePlateNumber" alt="Vehicle plate label">Plate</label>                
                                <span for="vehiclePlateNumberText" v-if="registrationInformation.plateNumber !='' || registrationInformation.plateType !=''">{{ registrationInformation.plateNumber }}/{{ registrationInformation.plateType }}
                                    <div class="statusTextFlex" v-if="registrationInformation.registrationStatus !=''">
                                        <img v-if="registrationInformation.registrationStatus == 'Active'" class="active-icon" src="static/status-active.png" alt="Icon">
                                        <img v-else class="active-icon" src="static/status-not-active.png" alt="Icon">
                                        <span class="statusText">{{ registrationInformation.registrationStatus }}</span>
                                    </div>
                                    
                                </span>
                            </div>
                            <div class="app-reg-info-child-group subTabCaret" v-if="!registrationInformation.showDetails">
                                <button class="showMoreText" role="button" alt="Show More or Less details" @click="isSubTabActive(registrationInformation)">{{registrationInformation.showDetails ? 'Less' : 'More...'}}</button>
                            </div>
                        </div>
                        <div class="app-reg-info-child-inspection-group"  v-if="isInspectionDueIn30Days(registrationInformation.inspectionDeadlineDate)">
                            <span class="inspectionStatusText">Your Vehicle emission inspection is due by <b>{{registrationInformation.inspectionDeadlineDate}}</b>; failure to obtain emission inspection certificate by this date will suspend your registration. For more information please refer to <a href=" https://dmv.ri.gov/registrations-plates-titles/safety-emissions-inspections/" target="_blank"
                                rel="noopener noreferrer">Safety and Emissions Inspections</a> page.
                            </span>
                        </div> 
                        <div class="app-reg-info-child-shipped-group" v-if="isPlateShipped(registrationInformation.shippedDate)">
                            <span class="shippedStatusText">
                                The plate for this registration has been shipped to you on <b>{{ registrationInformation.shippedDate }}</b> via <b>{{ registrationInformation.shippingMethod }}</b>. The tracking # is <b>{{ registrationInformation.trackingNumber }}</b>.
                            </span>
                        </div> 
                        <div class="app-reg-flex" v-if="registrationInformation.showDetails">
                            <div class="app-reg-info-child-group">
                                <label for="vehicleType">Vehicle type</label>                
                                <span for="vehicleTypeText">{{ registrationInformation.vehicleType }}</span>
                            </div>
                            <div class="app-reg-info-child-group">    
                                <label for="vehiclePlateDesign">Plate design</label>                
                                <span for="vehiclePlateDesignText">{{ registrationInformation.plateDesign }}</span>
                            </div>
                            <div class="app-reg-info-child-group">
                                <label for="vehicleExpirationDate">Expiration date</label>                
                                <img v-if="registrationInformation.expirationDate !='NA' && registrationInformation.expirationDate !=''" class="app-icon" src="@ridmv/web-themes/images/icons/calendar-solid.svg" alt="Icon">
                                <span for="vehicleExpirationDateText">{{ registrationInformation.expirationDate }}</span>
                            </div>
                            <div class="app-reg-info-child-group">
                                <label for="vehicleRegistrationRenewalFee">Registration renewal fee</label>                
                                <span for="vehicleRegistrationRenewalFeeText">{{ registrationInformation.registrationRenewalFee == 'NA' || registrationInformation.registrationRenewalFee == '' ? registrationInformation.registrationRenewalFee : `$ ${registrationInformation.registrationRenewalFee}` }}</span>
                            </div>
                        </div>
                        <div class="app-reg-flex" v-if="registrationInformation.showDetails">
                            <div class="app-reg-info-child-group">
                                <label for="vehicleOwnershipType">Ownership type</label>                
                                <span for="vehicleOwnershipTypeText">{{ registrationInformation.ownershipType }}</span>
                            </div>
                            <div class="app-reg-info-child-group">
                                <label for="vehicleOwnershipDocument">Ownership document</label>                
                                <span for="vehicleOwnershipDocumentText">{{ registrationInformation.ownershipDocument }}</span>
                            </div>
                            <div class="app-reg-info-child-group">
                                <label for="vehicleTitleNumber">Title number</label>                
                                <span for="vehicleTitleNumberText">{{ registrationInformation.titleNumber }}</span>
                            </div>  
                            <div class="app-reg-info-child-group">
                                <label for="vehicleTitleStatus">Status</label>                
                                <span for="vehicleTitleStatusText">{{ registrationInformation.titleStatus }}</span>
                            </div>
                        </div>
                        <div class="app-reg-flex" v-if="registrationInformation.showDetails ">
                            <div class="app-reg-info-child-group" v-if="registrationInformation.firstLienName!='' && registrationInformation.firstLienName!=null">
                                <label for="vehicleOwnershipType">Lien holder name (first)</label>                
                                <span for="vehicleOwnershipTypeText">{{registrationInformation.firstLienName}}</span>
                            </div>
                            <div class="app-reg-info-child-group" v-if="registrationInformation.firstLienDate!='' && registrationInformation.firstLienDate!=null"> 
                                <label for="vehicleOwnershipDocument">Lien date (first)</label>                
                                <span for="vehicleOwnershipDocumentText">{{registrationInformation.firstLienDate}}</span>
                            </div>
                            <div class="app-reg-info-child-group" v-if="registrationInformation.secondLienName!='' && registrationInformation.secondLienName!=null">
                                <label for="vehicleTitleNumber">Lien holder name (second)</label>                
                                <span for="vehicleTitleNumberText">{{registrationInformation.secondLienName}}</span>
                            </div>  
                            <div class="app-reg-info-child-group" v-if="registrationInformation.secondLienDate!='' && registrationInformation.secondLienDate!=null">
                                <label for="vehicleTitleStatus">Lien date (second)</label>                
                                <span for="vehicleTitleStatusText">{{registrationInformation.secondLienDate}}</span>
                            </div>
                            <div class="app-reg-child-lien-info" v-if="(registrationInformation.firstLienName!='' || registrationInformation.firstLienDate!='')">
                                <span>To remove the Lien information from your Title, please submit a 'Lien release letter' from the above financial institution(s).</span>
                            </div>
                        </div>
                        <div class="app-reg-flex" v-if="registrationInformation.showDetails && registrationInformation.suspensions.length > 0">
                            <div class="app-reg-info-child-grid-group">    
                                <label for="suspensionDescription">Suspension Description</label>                
                            </div>
                            <div class="app-reg-info-child-grid-group">
                                <label for="suspensionEffectiveDate">Suspension Effective Date</label>    
                            </div>
                            <div class="app-reg-info-child-grid-group">
                                <label for="suspensionStatus">Suspension Status</label> 
                            </div>
                        </div> 
                        <div class="app-reg-info-group" v-if="registrationInformation.showDetails && registrationInformation.suspensions">
                            <div class="app-reg-info-susp-row" v-for="(suspensionInfo, i) in registrationInformation.suspensions" :key="i">
                                <div class="app-reg-flex">
                                    <div class="app-reg-info-child-desc-group">    
                                        <span for="suspensionDescriptionText">{{ suspensionInfo.suspensionDescription }}</span>
                                    </div>
                                    <div class="app-reg-info-child-grid-group-text">
                                        <span for="suspensionEffectiveDateText">{{ suspensionInfo.suspensionEffectiveDate }}</span>
                                    </div>
                                    <div class="app-reg-info-child-grid-group-text">
                                        <span for="suspensionStatusText">{{ suspensionInfo.suspensionStatus }}</span>
                                    </div>
                                </div>      
                            </div>
                        </div>
                        <div class="app-reg-flex" v-if="registrationInformation.showDetails">
                            <div class="app-reg-info-child-group">
                                <button class="showMoreText" @click="isSubTabActive(registrationInformation)"> {{registrationInformation.showDetails ? 'Less' : 'More...'}}</button>
                            </div>
                        </div>
                        <div class="app-renew-reg">
                            <div v-if="registrationInformation.isPlateRenewable =='YES'">
                                <button class="renew-reg" tabindex="0" @enter="getSelectRenewRegistration(registrationInformation)" @click="getSelectRenewRegistration(registrationInformation)">
                                    Renew Registration
                                </button>
                            </div>
                            <div v-if="registrationInformation.isPlateCancelAllowed == 'YES'">
                                <button class="renew-reg" tabindex="0" @enter="getSelectCancelRegistration(registrationInformation)" @click="getSelectCancelRegistration(registrationInformation)">
                                    Cancel Registration
                                </button>
                            </div>
                            <div v-if="registrationInformation.isPlateDuplicateAllowed == 'YES'">
                                <button class="renew-reg" tabindex="0" @enter="getSelectDuplicateRegistration(registrationInformation)" @click="getSelectDuplicateRegistration(registrationInformation)">
                                    Duplicate Registration
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!registrationInfo.registrationInformation && networkResponse && !networkResponse.message" class="no-records">
                No Registration(s) found.
            </div>
        </div>
        <div v-if="registrationInfo == null && networkResponse && !networkResponse.message">
            No Registration(s) found.
        </div>  
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import * as COMMONS from '../../store/_commons';
import SystemAlert from '@/components/SystemAlert';

export default {
    name : 'Registration',
    data () {
        return {
        
        isActive: []
        }
    },

    components : {
        SystemAlert
    },

    computed: {			
        ...mapGetters({
            registrationInfo: COMMONS.GUEST_REGISTRATION_INFO,
            // errorMessageRegistration: COMMONS.GUEST_REGISTRATION_INFO_ERROR
            renewRegistrationInfo: COMMONS.GUEST_RENEWREGISTRATION_INFO,
        }),
        ...mapState([
            'networkResponse',
        ]),
            
        // sortRegistrationList() {
        //     // if(this.registrationInfo && this.registrationInfo.registrationInformation) { 
        //         let sortArray = this.registrationInfo.registrationInformation.sort((a,b) => {
        //             if(a.registrationStatus > b.registrationStatus) return -1;
        //             if(a.registrationStatus < b.registrationStatus) return 1;
        //             return 0;
        //         });
        //     // }
        //     // else return [];
        //     return sortArray;
        // },
    
    },

    methods: {
        ...mapActions({
            getSelectRenewReg: COMMONS.GUEST_SELECTRENEWREGISTRATION,
            getRenewRegistrationEligibility: COMMONS.GUEST_RENEWREGISTRATION,
            getDuplicateRegistrationEligibility: COMMONS.GUEST_DUPLICATEREGISTRATION,
            getCancelRegistrationEligibility: COMMONS.GUEST_CANCELREGISTRATION
        }),

        getRenewRegistration() {
            this.getRenewRegistrationEligibility();
        },

        getDuplicateRegistration() {
            this.getDuplicateRegistrationEligibility();
        },

        getCancelRegistration() {
            this.getCancelRegistrationEligibility();
        },

        isSubTabActive(isActive) {
            this.$set(isActive, 'showDetails', !isActive.showDetails);
        },

        isInspectionDueIn30Days(dateValue) {
            const inspectionDate = new Date(dateValue);   
            let  maxDate = new Date(); 
            const timeDifference = inspectionDate.getTime() - maxDate.getTime();
            const dateDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
            return dateDifference < 31 &&  dateDifference >= 0;
        },

        isPlateShipped(dateValue) {
            if(dateValue == '') {
                return false;
            } else {
                const shippedDate = new Date(dateValue);
                let  maxDate = new Date(); 
                const timeDifference = maxDate.getTime() - shippedDate.getTime();
                const dateDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
                return dateDifference < 91 &&  dateDifference >= 0;
            }
        },

        getSelectRenewRegistration(renewRegValue) {
            this.getSelectRenewReg(renewRegValue);
            this.getRenewRegistration();
            this.$store.state.guestLogin.step = 1;
        },

        getSelectDuplicateRegistration(renewRegValue) {
            this.getSelectRenewReg(renewRegValue);
            this.getDuplicateRegistration();
            this.$store.state.guestLogin.step = 1;
        },

        getSelectCancelRegistration(renewRegValue) {
            this.getSelectRenewReg(renewRegValue);
            this.getCancelRegistration();
            this.$store.state.guestLogin.step = 1;
        }
    },

    mounted() {
        window.scroll(0,0);
        document.getElementById("alert").focus();
    },
}
</script>

<style scoped lang="scss">
    .app-reg-info-row {
        margin: 15px 0px 18px 0px;
        align-items: center;
        border-bottom: 1px solid #F2F2F2;
        padding-bottom: 2rem;
        gap: 4rem;
        span, label {
            font-size: 1rem;
        }
        .app-reg-flex {
            display: flex;
            gap: 0rem 2rem;
            flex-wrap: wrap;
            .app-reg-info-child-group {
                width: 240px;
                padding: 1rem;
                .app-icon {
                    margin-right: 5px;
                    filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                    vertical-align: text-bottom;
                }
                .vehicleText {
                    font-size: 1.2rem;
                    font-weight: 700;
                }
                .statusText {
                    margin: 2px;
                }
                .statusTextFlex {
                    display: flex;
                }
            }

            .app-reg-info-child-desc-group {
                width: 240px;
                padding-left: 1rem;
            }
            .app-reg-info-child-grid-group-text {
                width: 240px;
                padding-left: 1rem;
            }
            .app-reg-info-child-grid-group {
                width: 240px;
                padding-left: 1rem;
                padding-top: 1rem;
            }
            .app-reg-child-lien-info{
                padding: 1rem;
            }
        }
        .app-reg-info-child-inspection-group {
            padding-left: 1rem ;
            padding-right: 1rem ;
            .inspectionStatusText {
                margin: 2px;        
            }
        }

        .app-reg-info-child-shipped-group{
            margin: 1rem;
        }
    }

    .app-reg-info-susp-row {
        display: flex;
        margin: 0px 0px 10px 0px;
        align-items: center;
        gap: 4rem; 
    }

    .active-icon {
        width: 25px;
        height: 25px;
        vertical-align: middle;
    }
    .subTabCaret {
        margin-top: 0.7rem;
        position: absolute;
        right: 10%;
    }
    .subtab-icon {
        height: 25px;
        width: 25px;
    }
    .showMoreText {
        cursor: pointer;
    }

    .app-renew-reg{
        display: flex;
        flex-wrap: wrap;
        text-align: center;          
        justify-content: center;  
        padding-left: 0.5rem;
    
        .renew-reg {
            color: var(--ri-blue);
            cursor: pointer;
            text-decoration: underline;
            border: none;
            border-radius: 0px;
            background-color: transparent;
            font-size: 16px;
            padding: 0px 0px;
            text-align: left;
            justify-content: center;
            font-weight: 100;
            padding-left: 2px;
            margin-top: 0.5rem;
            &:hover {
                text-decoration: none;
            }
        }
    }
    .app-reg-info-row:nth-child(odd) {
        background-color: #F2F2F2;
        // filter: contrast(1.5) brightness(0.9) grayscale(1.5);
    }

    .no-records {
        font-weight: 400;
    }
    
    @media only screen and (max-width: 726px) {
        .app-reg-info-row .app-reg-flex .app-reg-info-child-group {
            min-width: 155px;
        }
        .app-reg-info-child-group {
            span {
                word-wrap: break-word;
            }
        }
        .subTabCaret {
            width: 120px;
            position: static;
        }
    }
    @media only screen and (min-width: 727px)  {
        .app-reg-info-row .app-reg-flex .app-reg-info-child-group {
            width: 250px;
        }
        .subTabCaret {
            position: static;
        }
    }
</style>